import { atom, useAtom } from "jotai";
import { LDClient } from "launchdarkly-js-client-sdk";

export const clientAtom = atom<LDClient | null>(null);

export const useLaunchDarkly = () => {
  const [client, setClient] = useAtom(clientAtom);

  return {
    client,
    setClient,
  };
};
